/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useLocalStorage } from '@mantine/hooks'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'
import rest from '../../../../client/js/lib/rest'
import VersionNotesModal from './VersionNotesModal'

async function fetchAppVersion () {
  const resp = await rest.get('/api/app/version')
  return await resp.json()
}

function VersionNotesNotifier () {
  const [state, setState] = useLocalStorage({
    key: 'appVersionNotes',
    defaultValue: { version: null },
    getInitialValueInEffect: false
  })
  const versionQuery = useQuery({
    enabled: true,
    queryKey: ['versionNotes'],
    queryFn: () => fetchAppVersion(),
    refetchOnWindowFocus: false
  })
  const version = useMemo(() => versionQuery.data?.version, [versionQuery.data?.version])

  const closeModal = useCallback(() => {
    setState((s) => ({ ...s, version }))
  }, [setState, version])

  return (
    <VersionNotesModal
      onClose={closeModal}
      opened={state.version !== version && versionQuery.isFetched}
    />
  )
}

export default VersionNotesNotifier
